import data, { directionsName } from '../directionsData';

export default {
    MAIN: '/',
    DIRECTION: '/direction/:direction',
    RESEARCH: `/direction/${data[directionsName.RESEARCH].pathParams}`,
    DESIGN: `/direction/${data[directionsName.DESIGN].pathParams}`,
    LAUNCH: `/direction/${data[directionsName.LAUNCH].pathParams}`,
    TEAM: '/team',
    CONTACTS: '/contacts',
    MILESTONES: '/milestones',
};
